import { GetterTree } from 'vuex'
import { LocalStorageState, LocalStorageOneItem } from './state'
import { RootState } from '../../state'


export const getters: GetterTree<LocalStorageState, RootState> = {
  getLocalStorage(state): LocalStorageOneItem {
    return state.localStorage
  },
}
